import { gql } from "@apollo/client";
import { Query } from "~/common/graphql/__generated__/graphql";
import { Capitalized } from "~/common/graphql/capitalize";
import { appUrls } from "~/EasyProjectsCommon/AppUrls";
import { OAuthClient } from "~/EasyProjectsCommon/OAuthClient";

export const fetchMissingSpaces = async (spaceIds: number[]) => {
    const { data } = await OAuthClient.graphql<{ spaces: Capitalized<Query["spaces"]> }>(appUrls.spaces.graphql, {
        query: gql`
            query getMissingSpaces($settings: QuerySettingsInput) {
                spaces(settings: $settings) {
                    SpaceId: spaceId
                    Name: name
                    Color: color
                    Icon: icon
                    CanEdit: canEdit
                }
            }
        `,
        variables: {
            settings: {
                includeAllForAdmin: true,
                ids: spaceIds,
            },
        },
    });

    return data.spaces;
};
